import { useMemo } from 'react';

import { get } from 'ravenjs/utils/lodash';

import MESSAGES from 'constants/messages';

export function useProductsModal({ modal, schema }) {
    const open = get(modal, 'open', false);
    const userModalProps = get(modal, 'data.modalProps', {});
    const userId = get(userModalProps, 'userId', '');
    const companyName = get(userModalProps, 'companyName', '');
    const companyId = get(userModalProps, 'companyId', 0);
    const submittedCaseCount = get(userModalProps, 'submittedCaseCount', null);
    const ninetyDaySubmittedCount = get(userModalProps, 'ninetyDaySubmittedCount', null);
    const skus = get(userModalProps, 'skus', []);
    const title = `${MESSAGES.MODAL.VIEW_ALL_PRODUCTS.TITLE} ${companyName}`;

    const defaultParams = useMemo(() => {
        const order = get(schema, 'sorting.default.order');
        const orderBy = get(schema, 'sorting.default.orderBy');
        const limit = get(schema, 'pagination.rowsPerPage', 15);
        const params = {
            limit,
            offset: 0,
            searchSpec: '',
            sort: `${order === 'asc' ? '+' : '-'}${orderBy}`,
        };

        return params;
    }, [schema]);

    return {
        open,
        userId,
        companyId,
        companyName,
        submittedCaseCount,
        ninetyDaySubmittedCount,
        skus,
        title,
        params: defaultParams,
    };
}
